<template>
  <div class="component loader">
    <div class="fig">
      <div class="spinner">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="55" viewBox="0 0 50 55">
          <path fill="#333" fill-rule="evenodd" d="M25.8005492,39.8636304 L15.3138645,34.9747529 C14.2372409,34.4729404 13.7644989,33.1785069 14.2581379,32.0835839 L21.3565183,16.3350403 C21.8499441,15.2401174 23.1227439,14.7595571 24.1993675,15.2613696 L34.6860522,20.1502471 C35.7626758,20.6520596 36.2354178,21.9464931 35.741992,23.0414161 L28.6433984,38.7899597 C28.1499726,39.8848826 26.8771728,40.3654429 25.8005492,39.8636304"/>
        </svg>
      </div>
      <div class="base">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="55" viewBox="0 0 50 55">
          <path fill="#FFEA00" fill-rule="evenodd" d="M31.1660572,2.6279661 C27.3506144,0.457344633 22.6496023,0.457344633 18.8339428,2.6279661 L6.16605722,9.83391714 C2.35039773,12.0043252 0,16.0155995 0,20.3564156 L0,34.7685311 C0,39.1095606 2.35039773,43.1206215 6.16605722,45.2910295 L18.8339428,52.497194 C22.6496023,54.667602 27.3506144,54.667602 31.1660572,52.497194 L43.8339428,45.2910295 C47.6496023,43.1206215 50,39.1095606 50,34.7685311 L50,20.3564156 C50,16.0155995 47.6496023,12.0043252 43.8339428,9.83391714 L31.1660572,2.6279661 Z"/>
        </svg>
      </div>
      <div class="text">{{ $t('common.loading') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style lang="sass" scoped>
.loader
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  justify-content: center
  align-items: center

  z-index: 1060

  background-color: white

  font-family: sans-serif
  font-weight: 300

  .fig
    position: relative
    width: 50px
    height: 55px

  .spinner
    position: absolute
    top: 0
    left: 0
    z-index: 2

    animation: rotate 1.2s infinite cubic-bezier(.4, 0, .2, 1)

  .base
    position: absolute
    top: 0
    left: 0

  .text
    position: absolute
    top: 60px
    left: 0
    right: 0
    left: 0

    color: #777
    font-size: 0.75rem
    font-weight: 800
    text-align: center
    white-space: nowrap

@keyframes rotate
  0%
    transform: perspective(120px) rotateY(0deg)
  50%
    transform: perspective(120px) rotateY(180deg)
  100%
    transform: perspective(120px) rotateY(360deg)
</style>
